import Hero from '../components/sections/Hero';
import Stats from '../components/sections/Stats';
import FeaturedProducts from '../components/sections/FeaturedProducts';
import Testimonials from '../components/sections/Testimonials';
import HowItWorks from '../components/sections/HowItWorks';
import Newsletter from '../components/sections/Newsletter';

export default function Home() {
  return (
    <main>
      <Hero />
      <Stats />
      <FeaturedProducts />
      <Testimonials />
      <HowItWorks />
      <Newsletter />
    </main>
  );
}
